jQuery(document).ready(function($){
    $(document.body).removeClass('no-js').addClass('js');

    initPolyfills();

    // Utilities
    initClassToggle();
    initAnchorScroll();
    //initFullheightMobile();
    initHeroVideo();
    initSlick();
    initfullcoverVideos();
    $(window).resize(initfullcoverVideos);
    initAccordionTabs();
    initninjaForms();
    // var images = document.querySelectorAll('.parallax-img');
    // new simpleParallax(images, {
    //     scale: 1.4,
    //     delay: 1.4,
    //     transition: 'cubicBezier(.34,.615,.4,.985)'
    // });
});

function isMobile() {
    return window.matchMedia('(max-width:767px)').matches;
}

function initPolyfills() {
    // CSS object-fit for IE
    objectFitImages();

    // polyfill for IE - startsWith
    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function(searchString, position) {
            position = position || 0;
            return this.indexOf(searchString, position) === position;
        };
    }

    // polyfill for IE - forEach
    if ('NodeList' in window && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function (callback, thisArg) {
          thisArg = thisArg || window;
          for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
          }
        };
    }
}

function initAccordionTabs() {
    var $accordionTabs = $('.module__accordions');
    if (!$accordionTabs.length) {
        return;
    }
    function initTabs() {
        var $tabs = $accordionTabs.find('.module__accordions');
        if (!$tabs.length) {
            return;
        }
        var $triggers = $tabs.find('.tabs__link');
        $triggers.each(function() {
            var trigger = $(this);
            $(trigger).on('click', function(e){
                e.preventDefault();
                var target = $(trigger).data('target');
                if(target && !$(trigger).hasClass('active')) {
                    $(trigger).parent().find('.active').removeClass('active');
                    $(trigger).addClass('active');
                    $tabs.parent().parent().parent().find('.tabs__content.show').removeClass('show');
                    $tabs.parent().parent().parent().find(target).addClass('show');
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $('.module__faq--wrapper').offset().top
                    }, 1000);
                }
            })
        })
    }
    initTabs();
}


/**
 * Toggle class on click
 */
function initClassToggle() {
    $(document.body).on('click', '[data-toggle="class"][data-class]', function(event) {
        var $trigger = $(this);
        var $target = $($trigger.data('target') ? $trigger.data('target') : $trigger.attr('href'));

        if($target.length) {
            event.preventDefault();
            $target.toggleClass($trigger.data('class'));
            $trigger.toggleClass('classed');
        }
    });
}


/**
 * Smooth anchor scrolling
 */
function initAnchorScroll() {
    $('a[href*="#"]:not([data-toggle])').click(function(event) {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name="'+this.hash.slice(1)+'"]');
            if (target.length && !target.parents('.woocommerce-tabs').length) {
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);
            }
        }
    });
}



function initHeroVideo(){
    if($('.module__hero__video').length){
        var video = $('.module__hero__video').eq(0);
        var player = new Vimeo.Player(video);
        if(player){
            player.on('play', function(){
                $('.hide-on-play').fadeOut();
            })
        }

    }
}

function initSlick() {
    var $navPrev = $('.arrow-prev');
    var $navNext = $('.arrow-next');
     $('.module__image-slider--wrapper').on('init', function(event, slick) {
          $('.current').text(slick.currentSlide + 1);
          $('.total').text(slick.slideCount);
     })
          .slick({
          autoplay: true,
          autoplaySpeed: 3000,
          infinite: false,
          arrows: true,
          prevArrow: $navPrev,
          nextArrow: $navNext
     })
          .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          $('.current').text(nextSlide + 1);
     });
    var $test_navPrev = $('.module__testimonial--inner .arrow-prev');
    var $test_navNext = $('.module__testimonial--inner .arrow-next');
    $('.module__testimonial--slide').slick({
      autoplay: true,
      autoplaySpeed: 3000,
      infinite: true,
      arrows: true,
      prevArrow: $test_navPrev,
      nextArrow: $test_navNext
     })
}

function initfullcoverVideos() {
    $('.iframe-wrap').each(function () {
        var $container = $(this);
        var $iframe = $container.find('iframe');

        if ($iframe.length) {
            // Resize the iframe to cover the container
            cover($container, $iframe.attr('width'), $iframe.attr('height'));
        }

    });

    function cover($target, width, height) {
        var $panel = $target.parents('.module__home-hero--wrap');

        var winWidth = $panel.outerWidth();
        var winHeight = $panel.outerHeight();

        var ratio = height / width;
        var winRatio = winHeight / winWidth;

        if (winRatio > ratio) {
            $target.width(width * (winHeight / height));
            $target.height(winHeight);

            $target.css('top', 0);
            $target.css('left', (winWidth - $target.width()) / 2)
        } else {
            $target.width(winWidth);
            $target.height(height * (winWidth / width));

            $target.css('top', (winHeight - $target.height()) / 2);
            $target.css('left', 0)
        }
    }
} 


function initninjaForms() {
    $(document).on('nfFormSubmitResponse', function(e, args) {
        var $form = $('#nf-form-'+args.id+'-cont');
        var submitButton = $form.find('.submit-wrap button');
        var $form_inner = $form.find('form');

        // Change button text to "Thanks"
        submitButton.text('Thanks');
        submitButton.prop('disabled', true);
        // Clear the form after 5 seconds
        setTimeout(function() {
          $form_inner[0].reset();
          submitButton.text('Submit');
          submitButton.prop('disabled', false);
        }, 5000);
    });
}